/* src/app/shared/components/file-upload-input/file-upload-input.component.scss */
.main-container {
  display: flex;
  align-items: center;
}
.file-input {
  display: none;
}
.file-upload-container {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #DFEBF7;
  border-radius: 5px;
  color: #6B90B3;
  font: 400 14px FranceTV Brown;
  padding: 14px;
  background-color: #FFF;
}
.file-upload-label {
  margin-right: 10px;
  max-width: 80%;
  overflow-x: hidden;
}
/*# sourceMappingURL=file-upload-input.component.css.map */
